import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   status: false,
// }

// const sideBarSlice = createSlice({
//   name: 'prescriptions',
//   initialState,
//   reducers: {
//     toggleSideBar: (state) => {
//       console.log('got here');
//       state.status = !state.status
//     },
//     addNewPatient: (state, { payload }) => {
//       state.newPrescriptionData = payload
//       state.allPatients = [...state.allPatients, payload]
//     },
//     setCurrentPatient: (state, { payload }) => {
//       state.currentPatient = payload
//     },
//     resetCurrentPatient: (state) => {
//       state.currentPatient = {}
//     },
//   }
// })

// // const selectCurrentPatient = state => state.currentPatient;
// export const { toggleSideBar } = sideBarSlice.actions
// export default sideBarSlice.reducer





const initialState = {
  allPatients: [],
  currentPatient: {},
  status: false,
  // ... other state properties
};

const UPDATE_PATIENT = 'UPDATE_PATIENT'; // {{ edit_1 }} Define action type
const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'; // {{ edit_1 }} Define action type

export const updatePatient = (patient) => ({ // {{ edit_2 }} Action creator
  type: UPDATE_PATIENT,
  payload: patient,
});
export const toggleSideBar = (payload) => ({ // {{ edit_2 }} Action creator
    type: TOGGLE_SIDEBAR,
    payload
  });

const patientReducer1 = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PATIENT: // {{ edit_3 }} Handle the action
      return {
        ...state,
        allPatients: state.allPatients.map(p =>
          p.id === action.payload.id ? action.payload : p
        ),
      };
    case TOGGLE_SIDEBAR: // {{ edit_3 }} Handle the action
    return {
    ...state,
    status: action.payload,
    };
    // ... other cases
    default:
      return state;
  }
};

export default patientReducer1;